<app-full-map [toc]="false"></app-full-map>
